//IF YOU ARE MAKING CHANGES IN THIS FILE, UPDATE DESKTOP & MOBILE VERSION ALSO. [[JUST COPY PASTE]]
//NEED TO CHANGE SERVICE IMPORT & SERVICE DEPENDENCY INJECTION
// import { AdminService } from './admin.service';           FOR MOBILE
// import { ProductsService } from './products.service';           FOR DESKTOP

import { EventEmitter, Injectable } from '@angular/core';
import { Location } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { FormArray, FormGroup, Validators, FormBuilder, FormControl } from '@angular/forms';
import { catchError, debounceTime, distinctUntilChanged, tap } from 'rxjs/operators';
import { AdminService } from './admin.service';                 // FOR MOBILE
// import { ProductsService } from './products.service';           // FOR DESKTOP
import { Router } from '@angular/router';
import { ConfigService } from 'src/app/services/config.service';
import { environment } from 'src/environments/environment';
import { UtilityService } from '../services/utility.service';

@Injectable({
  providedIn: 'root'
})
export class VariantService {

  productAdded = new EventEmitter<void>();
  productAddedOrUpdatedSuccess = new EventEmitter<void>();

  isDesktop!: boolean; //initialize from the component
  // msgService!: any; //for notification
  conService!: any; //for confirmation

  // NOTIFICATION VARIABLES
  notificationMsg = '';
  showToast: boolean = false;
  isSuccess: boolean = true;

  deliverycharge:any;
  data:any;

  // FLASH MSG
  isShowFlash: boolean = false;
  flashMsg: string = ""

  // FORM DECLARATIONS
  productForm!: FormGroup;
  variantForm!: FormGroup;
  priceCalcForm!: FormGroup;
  addedCostItemForm!: FormGroup;

  toolbarData: any = {};
  page = 1;
  isEdit: boolean = false;
  productId: number = 0;
  variantGroup: number = 0;  //parent product id (for variant add)
  loading: boolean = false;
  isApiError: boolean = false;

  // data store
  fileToUpload!: File; //uploading image
  productsList: any[] = [];
  productsListLength: number = 0;
  categoryList: any[] = []; //main category array
  domainCategoryList: any[] = []; //domain category array
  selectedResellingCategory: any;
  resultCat: any[] = []; //category search result array
  selectedProduct: any = {}; //product edit details
  productToDelete: any = {};
  gstTypes: any[] = [];
  sizeValues: any[] = [];
  variantProductList: any[] = []   //store all variants 
  variantProductListCpy: any[] = []   //copy
  productDetailBackup: any = {};

  // flags
  isShowProductForm: boolean = false; //hide & show this component
  isSubmited: boolean = false;
  isNextPageClicked: boolean = false;
  IsSizeEnabled: boolean = false;   //HIDE N SHOW SIZE CHECKBOX
  IsColorEnabled: boolean = false;   //HIDE N SHOW COLOR CHECKBOX
  // isSingleReselling: boolean = false;
  isImagesModified: boolean = false; //to know if image deleted or added from product's multiple image array
  isExpandedCalculationForm = false;
  isSellingPriceCalculation: boolean = false; //to know if price calculation form is using for seller price calculation ro reseller price calculation
  // POPUPS
  popup: any = {
    showVariantForm: false,
    showProductForm: false, // popup form
    maxProductForm: false,
    showResellConfirm: false,
    showNotifyConfirm: false,
    showPriceConfigList: false,
    showPriceCalcForm: false,
    showAddFieldForm: false,
    showSavingProgress: false,
    showBackNav: false,
    showCategoryForm: false,
    showProdDelete: false
  }

  // VARIANTS ADD PROGRESS
  variantProgrss = {
    success: 0,
    failed: 0
  }
  productAddProgress: number = 0;
  progressPercent: number = 0;
  progressPercentStr: string = "0%";

  isReseller!: boolean;

  productSuccessConfirmationBanner: boolean = false;
  recentAddedProducts: any;
  productUrl?: any;

  routerPaths: any = {
    desktopProductList: 'Product/ProductList',
    mobileProductList: '/products/product-list'
  }
  constants: any = {
    digikariCommissionPercent: 5,
    bankChargesPercent: 2.36,
  }
  appName = environment.appName;
  ProductIdForPoduct: any;
  ProductAddSuccessBannerHead: any;

  generatedDescription: string = '';
  selectedDeliveryCharge: any;


  constructor(private fb: FormBuilder,
    private productService: AdminService,          // FOR MOBILE
    // private productService: ProductsService,      // FOR DESKTOP
    private configService: ConfigService,
    private location: Location,
    private router: Router,
    private utilityService: UtilityService) { }

  //THIS SHOULD BE THE FIRST METHOD TO BE CALLED
  public initVariantService(id: number) {
    this.productId = id;
    this.isReseller = this.configService.isReseller;
    if (this.isReseller) {
      this.configureForReseller();
    } else {
      this.configureForSeller();
    }
  }

  // RESELLER
  private configureForReseller() {
    this.initVariantForm();   //variant form
    if (this.productId == 0) {
      this.router.navigate(['/Reseller/AddProduct']);
    } else {
      this.setEditForm();
      this.getProductDetails(this.productId)
    }
  }

  // SELLER
  private configureForSeller() {
    let fieldPrefix = (this.isDesktop ? 'admin_desktop' : 'admin_mobile');

    this.populateToolbarData();
    this.initVariantForm();   //variant form
    this.initProductForm();    //product form
    this.getSellingPriceConfig(); //selling price calculation form
    this.initCostAddForm();   //cost field add form
    this.getCategories();
    this.getDeliveryChargeDetailsByProductId(this.productId);

    if (this.configService.setAppConfig(`${fieldPrefix}_productAdd_gstSelection`, false)) {
      this.getAllTax();
    }

    if (this.configService.setAppConfig(`${fieldPrefix}_resellerLoginEnabled`, false)) {
      this.getDomainCategories();
    }

    if (this.productId == 0) {
      this.setAddForm();
      this.getSellerCategorySettings();
      this.popup.showVariantForm = true;
    } else {
      this.setEditForm();
      this.getProductDetails(this.productId)
      // this.editProductClick(item);
    }
  }

  private populateToolbarData() {
    this.toolbarData.isShowRefresh = true;
  }

  public error() {
    this.isApiError = true;
    setTimeout(() => {
      this.isApiError = false;
    }, 2500);
  }

  public notify(status: boolean, msg: string, seconds: number = 5) {
    if (this.isDesktop) {
      this.configService.notify({ severity: status ? 'success' : 'error', summary: status ? 'Success' : 'Failed', detail: msg, })
    } else {
      this.showToast = true;
      this.isSuccess = status;
      this.notificationMsg = msg;
      setTimeout(() => {
        this.showToast = false;
      }, (seconds * 1000))
    }
  }

  public justFlash(msg: string) {
    this.isShowFlash = true;
    this.flashMsg = msg;
    setTimeout(() => {
      this.flashMsg = "";
      this.isShowFlash = false;
    }, 1000);
  }

  // FORM SECTION
  public initVariantForm() {
    this.variantForm = this.fb.group({
      isProductHaveVariant: ["no"],
      isColorEnabled: [""],
      isSizeEnabled: [""],
      prodVariantArray: this.fb.array([])
    })
    if (this.sizeValues.length) {
      this.addVariantField();
    }
  }

  private initProductForm() {
    this.productForm = this.fb.group({
      id: [0],
      productName: ["", [Validators.required, Validators.maxLength(1000)]],
      categoryName: [""],
      categoryId: ["", [Validators.required]],
      searchKeyword: ["", [Validators.maxLength(3000)]],
      outOfStock: [true],
      stock: ["", [Validators.pattern("^([0-9]{0,8})$")]],
      productWeight: ["", [Validators.required, Validators.pattern("^([0-9]{0,8})$")]],
      unitPrice: ["", [Validators.required, Validators.pattern("^([0-9]{0,8})$")]],
      purchasePrice: ["", [Validators.pattern("^([0-9]{0,8})$")]],
      purchasedCount: [0],
      mrp: ["", [Validators.required, Validators.pattern("^([0-9]{0,8})$")]],
      resellingPrice: [0],
      priceCalcValues: [""],
      gst: [""],
      sgst: [0],
      cgst: [0],
      resellingPriceConfig: [""],
      notifyConfig: [""],
      discountPercentage: [null, [Validators.pattern("^([0-9]|[1-9]?[0-9]|100)$")]],
      discountAmount: [null, [Validators.pattern("^([0-9]+)$")]],
      mrpDiscountPercentage: [null, [Validators.pattern("^([0-9]|[1-9]?[0-9]|100)$")]],
      mrpDiscountAmount: [null, [Validators.pattern("^([0-9]+)$")]],
      finalPrice: [null, [Validators.pattern("^([0-9]{0,8})$")]],
      description: [""],
      isProductPublished: [true],
      SeoKeywords: [""],
      ExternalProductLink: [""],
      youtubeProductLink: [""],
      additionalFields: this.fb.array([]),
      deliveryChargeProductID: [0],
      productTag: ""
    });

    if (this.configService.sellerConfiguration.ShowMRP) {
      this.productForm.get('mrp')?.setValidators([Validators.required, Validators.pattern("^([0-9]{0,8})$")]);
    } else {
      this.productForm.get('mrp')?.setValidators([Validators.pattern("^([0-9]{0,8})$")]);
    }

    let field = (this.isDesktop ? 'admin_desktop' : 'admin_mobile') + '_deliveryEnabled';
    if (!this.configService.setAppConfig(field, false)) {
      this.productForm.get('productWeight')?.setValue('0');
    }
    
    this.applyDiscountAndFinalPriceCalc();

  }

    private applyDiscountAndFinalPriceCalc() {
    this.productForm.get('unitPrice')?.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe(() => {
      this.calculateDiscountOnChanges(this.productForm.get('unitPrice')?.value, this.productForm.get('finalPrice')?.value);
      this.calculateMRPDiscountOnChanges(this.productForm.get('mrp')?.value, this.productForm.get('finalPrice')?.value);
    });

    this.productForm.get('mrp')?.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe((m) => {
      if (m) {
        this.productForm.get('unitPrice')?.setValue(m, { emitEvent: false });
        this.productForm.get('finalPrice')?.setValue(m);
        this.calculateDiscountOnChanges(this.productForm.get('unitPrice')?.value, this.productForm.get('finalPrice')?.value);
        this.calculateMRPDiscountOnChanges(this.productForm.get('mrp')?.value, this.productForm.get('finalPrice')?.value);
      } else {
        this.clearAllPriceDiscountValues();
      }
    });

    // SALES PRICE
    this.productForm.get('unitPrice')?.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe(v => {
      if (v != "") {
        this.productForm.get('discountPercentage')?.setValue(null, { emitEvent: false });
        this.productForm.get('discountAmount')?.setValue(null, { emitEvent: false });
        this.productForm.get('finalPrice')?.setValue(v, { emitEvent: false });
        this.calculateDiscountOnChanges(this.productForm.get('unitPrice')?.value, this.productForm.get('finalPrice')?.value);
        this.calculateMRPDiscountOnChanges(this.productForm.get('mrp')?.value, this.productForm.get('finalPrice')?.value);
      }
    });


    // DISCOUNT PERCENTAGE
    this.productForm.get('discountPercentage')?.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe(v => {
      // if (v != "") {
      if (v && v > 0) {
        const disAmount = this.getDiscountAmountFromPerc(v, this.productForm.get('unitPrice')?.value);
        if (disAmount > Number(this.productForm.get('unitPrice')?.value) && disAmount > Number(this.productForm.get('mrp')?.value)) {
          this.notify(false, 'Discount is higher than sales price');
          this.productForm.get('discountAmount')?.setValue(null, { emitEvent: false });
          this.productForm.get('discountPercentage')?.setValue(null, { emitEvent: false });
          this.productForm.get('finalPrice')?.setValue(Number(this.productForm.get('unitPrice')?.value), { emitEvent: false });
        } else {
          this.productForm.get('discountAmount')?.setValue(disAmount, { emitEvent: false });
          this.productForm.get('finalPrice')?.setValue(Number(this.productForm.get('unitPrice')?.value) - disAmount, { emitEvent: false });

        }
      } else {
        this.productForm.get('discountAmount')?.setValue(null, { emitEvent: false });
        this.productForm.get('discountPercentage')?.setValue(null, { emitEvent: false });
        this.productForm.get('finalPrice')?.setValue(Number(this.productForm.get('unitPrice')?.value), { emitEvent: false });
      }
      // }
    });

    // DISCOUNT AMOUNT
    this.productForm.get('discountAmount')?.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe(v => {
      if (v && v > 0) {
        if (Number(v) > Number(this.productForm.get('unitPrice')?.value) && Number(v) > Number(this.productForm.get('mrp')?.value)) {
          this.notify(false, 'Discount is higher than sales price');
          this.productForm.get('discountAmount')?.setValue(null, { emitEvent: false });
          this.productForm.get('discountPercentage')?.setValue(null, { emitEvent: false });
          this.productForm.get('finalPrice')?.setValue(Number(this.productForm.get('unitPrice')?.value), { emitEvent: false });
        } else {
          this.productForm.get('discountPercentage')?.setValue(this.getDiscountPrecFromAmount(v, this.productForm.get('mrp')?.value), { emitEvent: false });
          this.productForm.get('finalPrice')?.setValue(Number(this.productForm.get('mrp')?.value) - Number(v), { emitEvent: false });
        }
      } else {
        this.productForm.get('discountAmount')?.setValue(null, { emitEvent: false });
        this.productForm.get('discountPercentage')?.setValue(null, { emitEvent: false });
        this.productForm.get('finalPrice')?.setValue(Number(this.productForm.get('unitPrice')?.value), { emitEvent: false });
      }
    });

    // FINAL PRICE
    this.productForm.get('finalPrice')?.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe(v => {
      this.calculateDiscountOnChanges(this.productForm.get('unitPrice')?.value, v);
      this.calculateMRPDiscountOnChanges(this.productForm.get('mrp')?.value, v);
    });
  }

  private calculateMRPDiscountOnChanges(mrp: number, finalPrice: number) {
    if (finalPrice && finalPrice > 0 && mrp && mrp > 0) {
      if (Number(finalPrice) > mrp) {
        this.notify(false, 'Final price is higer than sales price');
        this.productForm.get('mrpDiscountAmount')?.setValue(null, { emitEvent: false });
        this.productForm.get('mrpDiscountPercentage')?.setValue(null, { emitEvent: false });
        this.productForm.get('finalPrice')?.setValue(Number(this.productForm.get('mrp')?.value), { emitEvent: false });
      } else {
        const discountAmount = mrp - Number(finalPrice);
        const discountPercentage = Math.round((discountAmount / mrp) * 100)

        this.productForm.get('mrpDiscountAmount')?.setValue(discountAmount, { emitEvent: false });
        this.productForm.get('mrpDiscountPercentage')?.setValue(discountPercentage, { emitEvent: false });
      }
    } else {
      this.productForm.get('mrpDiscountAmount')?.setValue(Number(this.productForm.get('mrp')?.value), { emitEvent: false });
      this.productForm.get('mrpDiscountPercentage')?.setValue(100, { emitEvent: false });
    }
  }

  private calculateDiscountOnChanges(mrp: number, finalPrice: number) {
    if (finalPrice && finalPrice > 0 && mrp && mrp > 0) {
      if (Number(finalPrice) > mrp) {
        this.notify(false, 'Final price is higer than sales price');
        this.productForm.get('discountAmount')?.setValue(null, { emitEvent: false });
        this.productForm.get('discountPercentage')?.setValue(null, { emitEvent: false });
        this.productForm.get('finalPrice')?.setValue(Number(this.productForm.get('unitPrice')?.value), { emitEvent: false });
      } else {
        const discountAmount = mrp - Number(finalPrice);
        const discountPercentage = Math.round((discountAmount / mrp) * 100)

        this.productForm.get('discountAmount')?.setValue(discountAmount, { emitEvent: false });
        this.productForm.get('discountPercentage')?.setValue(discountPercentage, { emitEvent: false });
      }
    } else {
      this.productForm.get('discountAmount')?.setValue(Number(this.productForm.get('unitPrice')?.value), { emitEvent: false });
      this.productForm.get('discountPercentage')?.setValue(100, { emitEvent: false });
    }
  }

  private clearAllPriceDiscountValues() {
    this.productForm.get('mrpDiscountPercentage')?.setValue(null, { emitEvent: false });
    this.productForm.get('mrpDiscountAmount')?.setValue(null, { emitEvent: false });
    this.productForm.get('discountPercentage')?.setValue(null, { emitEvent: false });
    this.productForm.get('discountAmount')?.setValue(null, { emitEvent: false });
    this.productForm.get('unitPrice')?.setValue(null, { emitEvent: false });
    this.productForm.get('finalPrice')?.setValue(null, { emitEvent: false });
  }

  public initPriceCalcForm() {
    this.priceCalcForm = this.fb.group({
      allCharges: this.fb.array([]),
      producedQTY: ["", [Validators.pattern("^([1-9][0-9]*)$")]],
      sellerPrice: ["", Validators.pattern("^([0-9]+)$")],
      finalPrice: [""],
      gstPercent: [""],
      gstAmount: [""],
      gst: [""],
      cgst: [""],
      sgst: [""],
    });
    this.priceCalcForm.valueChanges.pipe(
      debounceTime(300)
    ).subscribe((val: any) => {
      this.calcSellingPrice(val);
    })
  }

  public initCostAddForm() {
    this.addedCostItemForm = this.fb.group({
      index: [0],
      label: ["", [Validators.required]],
      value: ["", [Validators.pattern("(^[0-9]+$)")]],
      isLabelEdit: [false],
      isPrimary: [false]
    });
  }

  public setAddForm() {
    //toolbar reset
    this.toolbarData.isBack = false;
    this.toolbarData.title = 'Add product';

    // data clear
    this.fileToUpload
    this.resultCat = this.categoryList
    this.selectedProduct = {};
    this.variantProductList = [];
    this.selectedResellingCategory = null;

    this.page = 1;
    this.isEdit = false;
    this.productId = 0;
    this.variantGroup = 0;
    this.loading = false;
    this.isApiError = false;

    // flags reset
    this.isSubmited = false;
    this.isNextPageClicked = false;
    this.isSellingPriceCalculation = true;
    // this.isSingleReselling = false;

    //progress
    this.variantProgrss.success = 0;
    this.variantProgrss.failed = 0;
    this.productAddProgress = 0;
    this.progressPercent = 0;

    // close all popups
    Object.keys(this.popup).map((key: any) => this.popup[key] = false);

    //forms reset
    this.initProductForm(); //reset product form & set autoAutoStock to true
    this.initVariantForm(); //reset variant form & set isProductHaveVariant to no
    this.getSellingPriceConfig(); //RESET PRICE CALCULATION FORM
  }

  public setEditForm() {
    //toolbar reset
    this.toolbarData.isBack = false;
    this.toolbarData.title = 'Edit product';

    // data clear
    // this.fileToUpload
    this.resultCat = this.categoryList
    this.selectedProduct = {};
    this.variantProductList = [];
    this.selectedResellingCategory = null;

    this.isEdit = true;
    // this.productId = 0;
    // this.variantGroup = item.VariantGroup;
    // this.loading = false;
    this.isApiError = false;

    // flags reset
    this.isSubmited = false;
    this.isNextPageClicked = false;
    // this.isSingleReselling = false;
    this.isSellingPriceCalculation = true;
    this.isImagesModified = false;

    //progress
    this.variantProgrss.success = 0;
    this.variantProgrss.failed = 0;
    this.productAddProgress = 0;
    this.progressPercent = 0;

    // close all popups
    Object.keys(this.popup).map((key: any) => this.popup[key] = false);

    this.popup.showVariantForm = true;
    this.popup.showProductForm = true;
    this.popup.maxProductForm = true;

    //forms reset
    this.initProductForm(); //reset product form & set autoAutoStock to true
    this.initVariantForm(); //reset variant form & set isProductHaveVariant to no
    this.getSellingPriceConfig(); //RESET PRICE CALCULATION FORM
  }

  public getProductDetails(productId: any, remainingVariantsArray?: any) {
    this.productService.getProductDetails(productId).subscribe((res: any) => {
      if (res.Result == "Success" && res?.ResponseData) {
        let resProduct = res.ResponseData
        this.recentAddedProducts = res.ResponseData
        this.SetProductUrl(res.ResponseData)
        this.insertProductToList(resProduct);

        let variantArray = remainingVariantsArray ?? JSON.parse(resProduct?.ItemVariants ?? "[]");
        if (variantArray.length && !this.isReseller) {
          let index = variantArray.findIndex((element: any) => { return element.productId == resProduct.ID });
          if (!remainingVariantsArray) {  //this code is to set variant form data
            let colorValue = variantArray[index]?.productVariantParams.find((item: any) => { return item.VariantType == 'colorValue' })?.VariantValue;
            let sizeValue = variantArray[index]?.productVariantParams.find((item: any) => { return item.VariantType == 'sizeValue' })?.VariantValue;
            if (colorValue) {
              this.variantForm.controls['isColorEnabled'].setValue(true);
              this.variantForm.controls['isProductHaveVariant'].setValue('yes');
            }
            if (sizeValue) {
              this.variantForm.controls['isSizeEnabled'].setValue(true);
              this.variantForm.controls['isProductHaveVariant'].setValue('yes');
            }

          }
          variantArray.splice(index, 1);
        }

        if (this.variantForm.value.isProductHaveVariant == "yes") {
          this.popup.showVariantForm = true;
          this.page = 2;
        } else {
          this.page = 1;
          this.popup.showVariantForm = false;
        }

        if (variantArray.length && !this.isReseller) {
          this.getProductDetails(variantArray[0].productId, variantArray);
        }

        // this.getRemainingVariants(variantArray);
      }
    }, (error: HttpErrorResponse) => {
      this.error();
    });
  }

  private insertProductToList(productDetails: any) {
    let ProductSeoData = this.safeJsonParse(productDetails?.ProductSeoData) || {}
    let ExternalLinks = this.safeJsonParse(productDetails?.ExternalLinks) || {}
    let additionalInfoFields = this.safeJsonParse(productDetails?.AdditionalInfo) || [];
    let additionalFields = Array.isArray(additionalInfoFields) ? additionalInfoFields : [];
    let imageArr = JSON.parse(productDetails.MultiImages);
    this.productDetailBackup = this.isReseller ? JSON.parse(JSON.stringify(productDetails)) : {};
    const ytLinkIndex = imageArr.findIndex((r: any) => Object.keys(r).includes('youtubelink'));
    let youtubeLink = null;
    if (ytLinkIndex >= 0) {
      youtubeLink = imageArr[ytLinkIndex].youtubelink;
      imageArr.splice(ytLinkIndex, 1);
    }
    let formObj = {
      id: productDetails.ID,
      productName: productDetails.ProductName,
      categoryName: productDetails.CategoryName,
      categoryId: productDetails.CategoryID,
      searchKeyword: productDetails.SearchKeywords ?? "",
      outOfStock: productDetails.AutoOutOfStock,
      productWeight: productDetails?.ProductWeight ?? 0,
      stock: productDetails.Stock,
      unitPrice: productDetails.UnitPrice,
      purchasePrice: productDetails.PurchasePrice ?? 0,
      purchasedCount: productDetails.PurchasedCount,
      mrp: productDetails.MRP,
      discountAmount: Number(productDetails.UnitPrice - productDetails.FinalPrice),
      mrpDiscountAmount: Number(productDetails.MRP - productDetails.FinalPrice),
      discountPercentage: this.getDiscountPrecFromAmount(Number(productDetails.UnitPrice - productDetails.FinalPrice).toString(), productDetails.MRP),
      mrpDiscountPercentage: this.getDiscountPrecFromAmount(Number(productDetails.MRP - productDetails.FinalPrice).toString(), productDetails.MRP),
      finalPrice: (productDetails.UnitPrice - productDetails.Discount),
      description: productDetails.Description,
      SeoKeywords: ProductSeoData?.ProductSeokeywords ?? "",
      isProductPublished: productDetails?.IsProductPublish,
      ExternalProductLink: ExternalLinks?.ExternalProductLink ?? "",
      youtubeProductLink: youtubeLink ?? "",
      sgst: productDetails.SGST,
      cgst: productDetails.CGST,
      gst: (Number(productDetails.CGST) + Number(productDetails.SGST)),
      resellingPrice: "",
      notifyConfig: "",
      priceCalcValues: JSON.parse(productDetails?.SellerPriceConfig ?? "{}"),
      resellingPriceConfig: JSON.parse(productDetails?.ResellingPriceConfig ?? "{}"),
      deliveryChargeProductID: this.selectedDeliveryCharge?.DeliveryChargeProductID ?? "",
      additionalFields: additionalFields.map((item: any) => item.AdditionalInfo),
      productTag: productDetails?.ProductTag ?? ""
    }
    let currentVariantData = JSON.parse(productDetails?.CurrentVariantData ?? '[]');
    let colorIcon = currentVariantData.find((item: any) => { return item.variantType == 'colorIcon' })?.variantValue;
    let colorValue = currentVariantData.find((item: any) => { return item.variantType == 'colorValue' })?.variantValue;
    let sizeValue = currentVariantData.find((item: any) => { return item.variantType == 'sizeValue' })?.variantValue;

    let product = {
      status: "pending",
      touched: false,
      valid: true,
      colorIcon: colorIcon ?? "",
      colorValue: colorValue ?? "",
      sizeValue: sizeValue ?? "",
      productDetails: formObj,
      CGST: productDetails.CGST,
      SGST: productDetails.SGST,
      imageArray: imageArr,
      primaryImage: productDetails.Image
    }
    this.variantProductList.push(product);

    if (formObj.id == this.productId) {
      this.variantGroup = productDetails.VariantGroup;
      this.editVariantProduct(this.variantProductList[0]);
    }
  }


  // VARIANT SECTION
  get prodVariantArray(): FormArray {
    return this.variantForm.controls["prodVariantArray"] as FormArray;
  }

  public addVariantField() {
    const variant = this.fb.group({
      colorValue: [""],
      colorIcon: [""],
      sizeValue: [JSON.parse(JSON.stringify(this.sizeValues))],
      selectedSizeCount: 0,
      expand: false
    });
    this.prodVariantArray.push(variant);
  }

  public onEnterNewColor(variant: any, index: any) {
    if (variant.value.colorIcon == "" && variant.value.colorValue.length < 2 && this.variantForm.controls["prodVariantArray"].value.length == index + 1) {
      variant.controls["expand"].setValue(true);
      this.addVariantField();
    }
  }

  public closeAllSizeSelection() {
    this.variantForm.controls["prodVariantArray"].value.map((item: any) => {
      item.expand = false;
    })
  }

  public sizeClick(sizeItem: any, form: any) {
    sizeItem.isSelected = !sizeItem.isSelected;
    let count = form.value.sizeValue.reduce((size: any, item: any) => {
      if (item?.isSelected) {
        size++;
      }
      return size;
    }, 0)
    form.controls['selectedSizeCount'].setValue(count)
  }


  // VALUE RETURN METHODS
  private getDiscountAmountFromPerc(precent: string, unitPrice: number): number {
    return Math.round(unitPrice * (Number(precent) / 100));
  }

  private getDiscountPrecFromAmount(amount: string, unitPrice: number): number {
    return Math.round((Number(amount) / unitPrice) * 100);
  }

  public genSellingPriceConfigString(priceCalcValues: any) {
    if (priceCalcValues?.allCharges) {
      let allCharges: any = [];
      allCharges = priceCalcValues.allCharges.reduce((arr: any, item: any) => {
        if (item.label && item.value) {
          arr.push({ label: item.label, value: item.value });
        }
        return arr;
      }, [])
      priceCalcValues.allCharges = allCharges;
    } else {
      priceCalcValues = {};
    }
    return JSON.stringify(priceCalcValues);
  }

  public genResellingPriceConfigString(resellingPriceConfig: any) {
    if (resellingPriceConfig?.allCharges) {
      let allCharges: any = [];
      allCharges = resellingPriceConfig.allCharges.reduce((arr: any, item: any) => {
        if (item.label && item.value) {
          arr.push({ label: item.label, value: item.value });
        }
        return arr;
      }, [])
      resellingPriceConfig.allCharges = allCharges;
    } else {
      resellingPriceConfig = {};
    }
    return JSON.stringify(resellingPriceConfig);
  }

  public genCurrentVariantDataString(item: any) {
    let currentVariantData: any[] = [];
    let colorEnabled = this.variantForm.value.isColorEnabled;
    let sizeEnabled = this.variantForm.value.isSizeEnabled;
    if (sizeEnabled && item.sizeValue) {
      currentVariantData.push({ variantType: "sizeValue", variantValue: item.sizeValue });
    }
    if (colorEnabled && item.colorValue) {
      currentVariantData.push({ variantType: "colorValue", variantValue: item.colorValue });
    }
    if (colorEnabled && item.colorIcon) {
      currentVariantData.push({ variantType: "colorIcon", variantValue: item.colorIcon });
    }
    return JSON.stringify(currentVariantData);
  }


  // DROPDOWN VALUE SELECTION
  public selectCategory(item: any) {
    this.productForm.controls['categoryName'].setValue(item.CategoryName);
    this.productForm.controls['categoryId'].setValue(item.ID);
  }

  public selectGST(item: any) {
    this.productForm.controls['sgst'].setValue(item.SGSTValue);
    this.productForm.controls['cgst'].setValue(item.CGSTValue);
  }

  public selectGSTInPriceCalcForm(item: any) {
    this.priceCalcForm.controls['sgst'].setValue(item.SGSTValue);
    this.priceCalcForm.controls['cgst'].setValue(item.CGSTValue);
    let gstPercent = Number(item.CGSTValue) + Number(item.SGSTValue)
    this.priceCalcForm.controls['gstPercent'].setValue(gstPercent);
  }

public selectdeliverytyp(item: any){
  this.productForm.controls['deliveryChargeProductID'].setValue(item.deliveryChargeProductID);
}



  //PAGE NAVIGATION & RELATED METHODS
  public goBack() {
    if (this.page === 1) {
      this.location.back();
    } else {
      if (this.variantForm.value.isProductHaveVariant == "yes") {
        this.variantProductListCpy = JSON.parse(JSON.stringify(this.variantProductList))
        this.prodVariantArray.clear();
        this.reverseProcess();
        this.addVariantField();
      } else {
        this.page = 1;
      }
    }
    this.isNextPageClicked = false;
  }

  private reverseProcess() {
    let variant = this.variantProductListCpy.shift();
    const variantItem = this.fb.group({
      colorValue: [variant.colorValue],
      colorIcon: [variant.colorIcon],
      sizeValue: [JSON.parse(JSON.stringify(this.sizeValues))],
      selectedSizeCount: [1],
      expand: [false]
    });

    //set current size in color
    let size = variantItem.get('sizeValue')?.value.find((sizeItem: any) => {
      return variant.sizeValue == sizeItem.VariantType
    })

    if (size) {
      size.isSelected = true;
    }

    //set all remaining sizes in color
    this.setRemainingSizes(variantItem);

    this.prodVariantArray.push(variantItem)
    if (this.variantProductListCpy.length) {
      this.reverseProcess();
    } else {
      this.page = 1;
    }
  }

  private setRemainingSizes(form: any) {
    let color = form.get('colorValue').value;
    let count = form.get('selectedSizeCount').value;

    const index = this.variantProductListCpy.findIndex((item: any) => {
      return item.colorValue == color;
    });

    if (index != -1) {
      let size = form.get('sizeValue')?.value.find((sizeItem: any) => {
        return this.variantProductListCpy[index].sizeValue == sizeItem.VariantType
      })
      size.isSelected = true;
      form.get('selectedSizeCount').setValue(count + 1);

      this.variantProductListCpy.splice(index, 1);
      this.setRemainingSizes(form)
    } else {
      return;
    }
  }

  public nextPage() {
    if (this.page == 1) {
      if (this.variantForm.value.isProductHaveVariant == 'no') {
        this.popup.showProductForm = true;
        this.popup.maxProductForm = true;
      } else if (this.variantForm.value.isProductHaveVariant == 'yes') {
        this.isNextPageClicked = true;
        let isColorActive = this.variantForm.value.isColorEnabled;
        let isSizeActive = this.variantForm.value.isSizeEnabled;

        if (!isColorActive && isSizeActive) { //SIZE
          this.generateProductWithSize();

        } else if (isColorActive && !isSizeActive) { //COLOR
          this.generateProductWithColor();

        } else if (isColorActive && isSizeActive) { //SIZE & COLOR
          this.generateProductWithSizeNColor();

        } else {
          // this.notify(false, "No variation selected");
        }
      }
    } else {
      this.page++;
    }
    this.toolbarData.isBack = true;
  }

  public generateProductWithSize() {
    let variantProductListCpy: any[] = [];
    this.variantForm.value.prodVariantArray[0].sizeValue.map((itemSize: any) => {
      if (itemSize?.isSelected) {
        let product = {
          status: "pending",
          touched: false,
          valid: true,
          colorIcon: "",
          colorValue: "",
          sizeValue: itemSize.VariantType,
          productDetails: {},
          imageArray: [],
          primaryImage: ""
        }
        this.checkProductDetail(product);
        variantProductListCpy.push(product);
      }
    })
    if (variantProductListCpy.length > 0) {
      this.page = 2;
      this.variantProductList = variantProductListCpy;
      this.editVariantProduct(this.variantProductList[0]);
    } else {
      this.notify(false, "Select atlest one size");
    }
  }

  private checkProductDetail(product: any) {
    const index = this.variantProductList.findIndex((item: any) => {
      return (item.colorValue === product.colorValue && item.sizeValue === product.sizeValue)
    });
    if (index != -1) {
      product.productDetails = this.variantProductList[index].productDetails;
      product.primaryImage = this.variantProductList[index].primaryImage;
      product.imageArray = this.variantProductList[index].imageArray;
      product.touched = this.variantProductList[index].touched;
      this.variantProductList.splice(index, 1);
    }
  }

  public generateProductWithColor() {
    let variantProductListCpy: any[] = [];
    this.variantForm.value.prodVariantArray.map((itemColor: any) => {
      if (itemColor.colorValue) {
        let product = {
          status: "pending",
          touched: false,
          valid: true,
          colorIcon: itemColor.colorIcon,
          colorValue: itemColor.colorValue,
          sizeValue: "",
          productDetails: {},
          imageArray: [],
          primaryImage: ""
        }
        this.checkProductDetail(product);
        variantProductListCpy.push(product);
      }
    })
    if (variantProductListCpy.length > 0) {
      this.page = 2;
      this.variantProductList = variantProductListCpy;
      this.editVariantProduct(this.variantProductList[0]);
    } else {
      this.notify(false, "Add atlest one color");
    }
  }

  public generateProductWithSizeNColor() {
    let isValid = true;
    let variantProductListCpy: any[] = [];
    this.variantForm.value.prodVariantArray.map((itemColor: any) => {
      itemColor.sizeValue.map((itemSize: any) => {
        if (itemColor.colorValue && itemSize?.isSelected) {
          let product = {
            status: "pending",
            touched: false,
            valid: true,
            colorIcon: itemColor.colorIcon,
            colorValue: itemColor.colorValue,
            sizeValue: itemSize.VariantType,
            productDetails: {},
            imageArray: [],
            primaryImage: ""
          }
          this.checkProductDetail(product);
          variantProductListCpy.push(product);
        }
      })
      if ((itemColor.colorValue && itemColor.selectedSizeCount == 0) ||
        (!itemColor.colorValue && (itemColor.selectedSizeCount != 0))) {
        isValid = false;
      }
    })
    if (variantProductListCpy.length > 0 && isValid) {
      this.page = 2;
      this.variantProductList = variantProductListCpy;
      this.editVariantProduct(this.variantProductList[0]);

    } else if (this.variantProductList.length == 0 && isValid) {
      this.notify(false, "Add atlest one color");
    }
  }


  // COST CALCULATION SECTION
  //set selling price calculation form
  public getSellingPriceConfig() {
    let PriceCalculationConfigKeys = this.productService.getLoginDetails()?.PriceCalculationConfigKeys;
    this.initPriceCalcForm();
    if (PriceCalculationConfigKeys) {
      PriceCalculationConfigKeys.split(",").map((keys: any) => {
        if (keys === 'Expected Margin') {
          this.priceCalcForm.addControl('expectedMargin', this.fb.control("", [Validators.pattern("(^[0-9]+$)")]))

        } else if (keys === 'Bank Charges+GST') {
          this.priceCalcForm.addControl('bankCharges', this.fb.control("", [Validators.pattern("(^[0-9]+$)")]))

        } else if (keys != 'App Courior Charges' && keys != 'digikari Commission+GST') {
          let primaryCharge = this.fb.group({
            index: [0],
            isLabelEdit: [false],
            label: [keys, [Validators.required]],
            value: ["", [Validators.pattern("(^[0-9]+$)")]],
            isPrimary: [true]
          });
          this.allCharges.push(primaryCharge)
        }
      })
    }
  }

  //set reselling price calculation form
  public getResellingPriceConfig() {
    let ResellingPriceCalculationConfigKeys = this.productService.getLoginDetails()?.ResellingPriceCalculationConfigKeys;
    this.initPriceCalcForm();
    if (ResellingPriceCalculationConfigKeys) {
      ResellingPriceCalculationConfigKeys.split(",").map((keys: any) => {
        if (keys === 'Expected Margin') {
          this.priceCalcForm.addControl('expectedMargin', this.fb.control("", [Validators.pattern("(^[0-9]+$)")]))

        } else if (keys === 'digikari Commission') {
          this.priceCalcForm.addControl('digikariCommission', this.fb.control("", [Validators.pattern("(^[0-9]+$)")]))

        } else if (keys === 'Bank Charges') {
          this.priceCalcForm.addControl('bankCharges', this.fb.control("", [Validators.pattern("(^[0-9]+$)")]))

        } else if (keys != 'CGST' && keys != 'SGST' && keys != 'App Courior Charges') {
          let primaryCharge = this.fb.group({
            index: [0],
            isLabelEdit: [false],
            label: [keys, [Validators.required]],
            value: ["", [Validators.pattern("(^[0-9]+$)")]],
            isPrimary: [true]
          });
          this.allCharges.push(primaryCharge)
        }
      })
    }
  }

  get allCharges() {
    return this.priceCalcForm.get("allCharges") as FormArray;
  }

  public addCostFieldClick() {
    this.addedCostItemForm = this.fb.group({
      index: [0],
      label: ["", [Validators.required]],
      value: ["", [Validators.pattern("(^[0-9]+$)")]],
      isLabelEdit: [false],
      isPrimary: [false]
    });
    this.popup.showAddFieldForm = true;
  }

  public removeCostField() {
    const index = this.addedCostItemForm.value.index;
    this.allCharges.removeAt(index);
    this.popup.showAddFieldForm = false;
  }

  public saveOrAddCostField() {
    this.addedCostItemForm.markAllAsTouched();
    if (this.addedCostItemForm.controls['label'].valid) {
      if (this.addedCostItemForm.value.isLabelEdit) {
        this.updateCostField();
      } else {
        this.addCostField();
      }
      this.popup.showAddFieldForm = false;
    }
  }

  public addCostField() {
    this.allCharges.push(this.addedCostItemForm);
  }

  public updateCostField() {
    const index = this.addedCostItemForm.value.index;
    const editItem = this.allCharges.at(index);
    editItem.setValue(this.addedCostItemForm.value);
  }

  public editCostLabelClick(item: any, index: number) {
    this.addedCostItemForm = this.fb.group(item.value);
    this.addedCostItemForm.get('label')?.setValidators(Validators.required);
    this.addedCostItemForm.controls['isLabelEdit'].setValue(true);
    this.addedCostItemForm.controls['index'].setValue(index);
    this.popup.showAddFieldForm = true;
  }

  public closePriceCalculationForm() {
    if (!this.isSellingPriceCalculation && this.variantForm.value.isProductHaveVariant == 'no') {
      this.forceSaveProduct();
    }
    this.popup.showPriceCalcForm = false
  }

  public changePriceCalculationForm() {
    this.isExpandedCalculationForm = !this.isExpandedCalculationForm;
    this.calcSellingPrice(this.priceCalcForm.value);
  }

  // public calcSellingPrice(formValues: any) { 
  //   let totalPriceWithoutTax: number = 0;
  //   let unitPriceWithoutTax: number = 0;
  //   let expMarginAmount: number = 0;
  //   let totalTaxPercent: number = 0;
  //   let taxAmount: number = 0;
  //   let finalPrice: number = 0;
  //   formValues.allCharges.map((item: any) => { totalPriceWithoutTax += Number(item.value) });
  //   if (formValues?.expectedMargin) {
  //     expMarginAmount = totalPriceWithoutTax * (Number(formValues.expectedMargin) / 100);
  //     totalPriceWithoutTax += expMarginAmount;
  //   }
  //   unitPriceWithoutTax = totalPriceWithoutTax / Number(formValues.producedQTY);
  //   totalTaxPercent = Number(formValues.cgst) + Number(formValues.sgst);
  //   if (totalTaxPercent>0) {
  //     taxAmount = unitPriceWithoutTax * (totalTaxPercent / 100)
  //   }
  //   finalPrice = unitPriceWithoutTax + taxAmount;
  //   this.priceCalcForm.controls["sellingPrice"].setValue(Math.round(finalPrice), { emitEvent: false });
  // }

  public calcSellingPrice(formValues: any) {
    if (!this.isExpandedCalculationForm && this.priceCalcForm.get('sellerPrice')?.valid) {
      let finalPrice: number = 0;
      let digikariCommission = 0;
      let bankCharges = 0;
      let sellerPrice: number = 0;

      let gstPercent = Number(formValues.gstPercent);
      let gstAmount: number = 0;

      sellerPrice = Number(formValues.sellerPrice);
      digikariCommission = sellerPrice * (this.constants.digikariCommissionPercent / 100);
      bankCharges = sellerPrice * (this.constants.bankChargesPercent / 100);
      finalPrice = Math.ceil(sellerPrice) + Math.ceil(bankCharges) + Math.ceil(digikariCommission);

      if (gstPercent > 0) {
        gstAmount = sellerPrice * (gstPercent / 100)
        finalPrice = finalPrice += gstAmount;
        this.priceCalcForm.controls["gstAmount"]?.setValue(Math.ceil(gstAmount), { emitEvent: false });
      }

      this.priceCalcForm.controls["digikariCommission"]?.setValue(Math.ceil(digikariCommission), { emitEvent: false });
      this.priceCalcForm.controls["bankCharges"]?.setValue(Math.ceil(bankCharges), { emitEvent: false });
      this.priceCalcForm.controls["finalPrice"]?.setValue(Math.ceil(finalPrice), { emitEvent: false });

    } else if (this.isExpandedCalculationForm && this.priceCalcForm.valid && Number(formValues.producedQTY) > 0) {
      let finalPrice: number = 0;
      let digikariCommission = 0;
      let bankCharges = 0;
      let sellerPrice: number = 0;

      let expMarginAmount: number = 0;
      let producedQTY: number = 0;
      let gstPercent = Number(formValues.gstPercent);
      let gstAmount: number = 0;

      sellerPrice = formValues.allCharges.reduce((sum: any, item: any) => { return sum += item.value }, 0);

      producedQTY = Number(formValues.producedQTY);
      sellerPrice = (sellerPrice / producedQTY);
      this.priceCalcForm.controls["sellerPrice"]?.setValue(Math.ceil(sellerPrice), { emitEvent: false });

      //if entered expected margin
      if (formValues?.expectedMargin) {
        expMarginAmount = sellerPrice * (Number(formValues.expectedMargin) / 100);
        sellerPrice += expMarginAmount;
      }

      digikariCommission = (!this.isSellingPriceCalculation) ? (sellerPrice * (this.constants.digikariCommissionPercent / 100)) : 0;
      bankCharges = sellerPrice * (this.constants.bankChargesPercent / 100);

      finalPrice = Math.ceil(sellerPrice) + Math.ceil(bankCharges) + Math.ceil(digikariCommission);

      if (gstPercent > 0) {
        gstAmount = sellerPrice * (gstPercent / 100)
        finalPrice = finalPrice += gstAmount;
        this.priceCalcForm.controls["gstAmount"]?.setValue(Math.ceil(gstAmount), { emitEvent: false });
      }

      this.priceCalcForm.controls["digikariCommission"]?.setValue(Math.ceil(digikariCommission), { emitEvent: false });
      this.priceCalcForm.controls["bankCharges"]?.setValue(Math.ceil(bankCharges), { emitEvent: false });
      this.priceCalcForm.controls["finalPrice"]?.setValue(Math.ceil(finalPrice), { emitEvent: false });
    }
  }

  public showSellingPriceCalcFormClick() {
    this.popup.showPriceCalcForm = true;
    this.isExpandedCalculationForm = true;
    this.isSellingPriceCalculation = true;

    if (this.productForm.value.priceCalcValues) {
      this.priceCalcForm.setValue(this.productForm.value.priceCalcValues);
    } else {
      this.getSellingPriceConfig(); //RESET PRICE CALCULATION FORM
      this.priceCalcForm.controls['producedQTY'].setValue(this.productForm.value.stock);

      this.priceCalcForm.controls["gst"].setValue(this.productForm.value.gst);
      this.priceCalcForm.controls["sgst"].setValue(this.productForm.value.sgst);
      this.priceCalcForm.controls["cgst"].setValue(this.productForm.value.cgst);
      let gstPercent = Number(this.productForm.value.sgst) + Number(this.productForm.value.cgst);
      this.priceCalcForm.controls['gstPercent'].setValue(gstPercent);

    }
  }

  public applySellingPriceConfigClick() {
    this.priceCalcForm.markAllAsTouched();
    if (this.priceCalcForm.valid && this.priceCalcForm.value.finalPrice > 0) {
      this.productForm.controls["unitPrice"].setValue(this.priceCalcForm.value.finalPrice);

      this.productForm.controls["gst"].setValue(this.priceCalcForm.value.gst);
      this.productForm.controls["sgst"].setValue(this.priceCalcForm.value.sgst);
      this.productForm.controls["cgst"].setValue(this.priceCalcForm.value.cgst);

      this.productForm.controls["priceCalcValues"].setValue(this.priceCalcForm.value);
      // this.priceCalcForm.reset();
      this.popup.showPriceCalcForm = false;
    } else {
      this.notify(false, "Invalid value")
    }
  }

  public applyResellingPriceClick() {
    this.priceCalcForm.markAllAsTouched();
    if (this.selectedProduct.productDetails.mrp < this.priceCalcForm.value.finalPrice) {
      this.notify(false, "Final price should be less than MRP");
    } else if (this.priceCalcForm.valid) {
      this.selectedProduct.productDetails.resellingPriceConfig = this.priceCalcForm.value;
      this.selectedProduct.valid = true;
      this.popup.showPriceCalcForm = false;
    }
  }

  public applyResellingPriceToAllClick() {
    this.priceCalcForm.markAllAsTouched();
    if (this.priceCalcForm.valid) {
      this.variantProductList.map((item: any) => {
        if (item.productDetails.mrp < this.priceCalcForm.value.finalPrice) {
          this.notify(false, "Final price should be less than MRP");
        } else {
          item.productDetails.resellingPriceConfig = this.priceCalcForm.value;
          item.valid = true;
        }
      })
      this.popup.showPriceCalcForm = false;
    }
  }


  // PRODUCT LIST
  public applyVariantDetails() {
    this.isSubmited = true;
    if (Number(this.productForm.value.unitPrice) > Number(this.productForm.value.mrp)) {
      this.notify(false, "Unit can't be higher than MRP");

    } else if (this.productForm.valid) {
      this.selectedProduct.productDetails = JSON.parse(JSON.stringify(this.productForm.value));
      this.selectedProduct.valid = true;
      this.popup.showProductForm = false;
      this.isSubmited = false;

      this.variantProductList.map((item: any) => { // variant products can't have multiple category id
        if (Object.keys(item.productDetails).length) {
          item.productDetails.categoryId = this.productForm.get('categoryId')?.value;
          // item.productDetails.categoryName = this.productForm.get('categoryName')?.value;
          item.touched = true;
        }
      })
    } else {
      this.selectedProduct.valid = false;
    }
  }

  public applyVariantDetailsAll() {
    this.isSubmited = true;
    if (Number(this.productForm.value.unitPrice) > Number(this.productForm.value.mrp)) {
      this.notify(false, "Unit can't be higher than MRP");

    } else if (this.productForm.valid) {
      this.variantProductList.map((item: any) => {
        if (!Object.keys(item.productDetails).length) {
          item.productDetails = JSON.parse(JSON.stringify(this.productForm.value));
          item.imageArray = JSON.parse(JSON.stringify(this.selectedProduct.imageArray));
          item.primaryImage = this.selectedProduct.primaryImage;
          item.valid = true;
        }
      })
      this.selectedProduct.valid = true;
      this.popup.showProductForm = false;
      this.isSubmited = false;
    }
  }

  //sets popup form data
  public editVariantProduct(item: any) {
    item.touched = true;
    this.selectedProduct = item;
    this.initProductForm();
    if (Object.keys(this.selectedProduct.productDetails).length) {
      this.handleAdditionalFields(this.selectedProduct.productDetails.additionalFields);
      this.productForm.setValue(this.selectedProduct.productDetails, { emitEvent: false });
      let gst = this.selectedProduct.productDetails.sgst + this.selectedProduct.productDetails.sgst
      this.productForm.get('gst')?.setValue(gst + ' %')
    }
    this.popup.showProductForm = true;
    this.popup.maxProductForm = true;
  }
  private handleAdditionalFields(additionalFields: any) {
    const additionalFieldsArray = this.productForm.get('additionalFields') as FormArray;
    additionalFieldsArray.clear();
    if (Array.isArray(additionalFields)) {
      additionalFields.forEach((field: any) => {
        let fieldControl = this.fb.group({
          label: [field.label || ''],
          icon: [field.icon || ''],
          type: [field.type || ''],
          value: [field.value || ''],
          isActive: [field.isActive ?? true]
        });
        additionalFieldsArray.push(fieldControl);
      });
    }
  }
  //  OTHER METHODS
  public submitClick() {
    this.isSubmited = true;

    // Sanitize YouTube product link first
    const youtubeControl = this.productForm.get('youtubeProductLink');
    const rawYoutubeLink = youtubeControl?.value?.trim();

    if (rawYoutubeLink) {
      const sanitized = this.utilityService.sanitizeUrl(rawYoutubeLink);
      if (!sanitized) {
        youtubeControl?.setErrors({ invalidUrl: true });
        this.notify(false, 'Invalid YouTube link');
        return;
      } else {
        youtubeControl?.setValue(sanitized, { emitEvent: false });
        youtubeControl?.setErrors(null);
      }
    } else {
      youtubeControl?.setErrors(null);
    }


    if (this.isReseller) {
      if (Number(this.productForm.value.unitPrice) > Number(this.productForm.value.mrp)) {
        this.notify(false, "Unit can't be higher than MRP");

      } else if (Number(this.productForm.value.unitPrice) < Number(this.productForm.value.resellingPriceConfig.finalPrice)) {
        this.notify(false, "Unit can't be lower than Seller price");

      } else if (this.productForm.invalid) {
        this.notify(false, "Invalid data");

      } else {
        this.saveChangeRequest();
      }
    } else if (this.variantForm.value.isProductHaveVariant === "no") {
      if (Number(this.productForm.value.unitPrice) < Number(this.productForm.value.discountAmount)) {
        this.notify(false, 'Discount is higher than sales price');

      } else if (this.configService.sellerConfiguration.ShowMRP && Number(this.productForm.value.unitPrice) > Number(this.productForm.value.mrp)) {
        this.notify(false, "Unit can't be higher than MRP");

      } else if (this.productForm.invalid) {
        this.notify(false, "Provide all the required fields or Invalid data");

      } else {
        this.resellConfirmInit();
      }
    } else if (this.variantForm.value.isProductHaveVariant === "yes") {
      let valid: boolean = true;
      this.variantProductList.map((item: any) => {
        if (!Object.keys(item.productDetails).length) {
          valid = false;
          item.valid = false;
        }
      })
      if (valid) {
        this.resellConfirmInit();
      } else {
        this.notify(false, "Product details required");
      }
    }
  }

  public cancelClick() {
    if (this.isReseller || this.variantForm.value?.isProductHaveVariant == 'no') {
      let path: string;
      if (this.isDesktop) {
        path = '/Product/ProductList';
      } else {
        path = '/products/product-list';
      }
      this.router.navigate([path]);

    } else {
      this.popup.showProductForm = false;
    }
  }

  public resellConfirmInit() {
    let field = (this.isDesktop ? 'admin_desktop' : 'admin_mobile') + '_resell_productResellingEnabled';
    if (this.isEdit || !this.configService.setAppConfig(field, false)) {
      this.forceSaveProduct();
      return;
    }
    this.popup.showProductForm = false;
    this.popup.showVariantForm = false;
    if (this.isDesktop) {
      this.conService.confirm({
        message: 'Do you want to resell this product?',
        header: 'Confirmation',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.resellProductClick();
        },
        reject: () => {
          this.forceSaveProduct()
        }
      });
    } else {
      this.popup.showResellConfirm = true;
    }
  }

  public notifyConfirmInit() {
    if (this.isDesktop) {
      this.conService.confirm({
        message: 'Enable notification for modification in product?',
        header: 'Confirmation',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.notifyForModificationClick();
        },
        reject: () => {
          this.forceSaveProduct()
        }
      });
    } else {
      this.popup.showNotifyConfirm = true;
    }
  }

  public resellProductClick() {
    this.popup.showResellConfirm = false;
    this.getResellingPriceConfig();
    if (this.variantForm.value.isProductHaveVariant == "yes") {
      this.popup.showPriceConfigList = true;
      this.variantProductList.map((item: any) => {
        item.productDetails.isReselling = true;
        item.valid = true;
      })
    } else if (this.variantForm.value.isProductHaveVariant == "no") {
      this.popup.showPriceCalcForm = true;
      this.isSellingPriceCalculation = false;
      this.isExpandedCalculationForm = false;
      this.priceCalcForm.controls['producedQTY'].setValue((this.productForm.value.stock > 0) ? this.productForm.value.stock : 1);
      let gstPercent = Number(this.productForm.value.sgst) + Number(this.productForm.value.cgst);
      this.priceCalcForm.controls['gstPercent'].setValue(gstPercent);
      this.priceCalcForm.controls['gst'].setValue(this.productForm.value.gst);
      this.priceCalcForm.controls['cgst'].setValue(this.productForm.value.cgst);
      this.priceCalcForm.controls['sgst'].setValue(this.productForm.value.sgst);

      // this.isSingleReselling = true;
    }
  }

  public notifyForModificationClick() {
    if (this.variantForm.value.isProductHaveVariant == "no") {
      this.productForm.controls['notifyConfig'].setValue({ image: true, unitPrice: true });
    } if (this.variantForm.value.isProductHaveVariant == "yes") {
      this.popup.showSavingProgress = true;
      this.variantProductList.map((item: any) => {
        item.productDetails.notifyConfig = { image: true, unitPrice: true };
      })
    }
    this.forceSaveProduct();
  }

  public forceSaveProduct() {
    if (this.variantForm.value.isProductHaveVariant == "no") {
      this.addOrUpdateSingleProd();
    } if (this.variantForm.value.isProductHaveVariant == "yes") {
      this.popup.showSavingProgress = true;
      this.itrateProductList();
    }
  }

  public modifyResellingProductClick(item: any) {
    this.popup.showPriceCalcForm = true;
    this.isSellingPriceCalculation = false;
    this.isExpandedCalculationForm = false;
    this.selectedProduct = item;
    if (item.productDetails.resellingPriceConfig) {
      this.priceCalcForm.setValue(item.productDetails.resellingPriceConfig);
    } else {
      this.allCharges.controls.map((item: any) => {
        item.get('value').reset();
      })
      this.priceCalcForm.get('bankCharges')?.reset();
      this.priceCalcForm.get('digikariCommission')?.reset();
      this.priceCalcForm.get('expectedMargin')?.reset();

      this.priceCalcForm.get('producedQTY')?.setValue((item.productDetails?.stock > 0) ? item.productDetails.stock : 1);
      let gstPercent = Number(item.productDetails.sgst) + Number(item.productDetails.cgst);
      this.priceCalcForm.controls['gstPercent'].setValue(gstPercent);

      this.priceCalcForm.controls['gst'].setValue(item.productDetails.gst);
      this.priceCalcForm.controls['cgst'].setValue(item.productDetails.cgst);
      this.priceCalcForm.controls['sgst'].setValue(item.productDetails.sgst);


      this.priceCalcForm.get('sellerPrice')?.reset()
      this.priceCalcForm.get('finalPrice')?.reset()

      // this.priceCalcForm.controls['expectedMargin'].reset();
      // this.priceCalcForm.controls['producedQTY'].reset();
      // this.priceCalcForm.controls['gst'].reset();
      // this.priceCalcForm.controls['cgst'].reset();
      // this.priceCalcForm.controls['sgst'].reset();
      // this.priceCalcForm.controls['sellingPrice'].reset();
    }
  }

  public applySingleResellingPriceConfig() {
    this.priceCalcForm.markAllAsTouched();
    if (this.productForm.value.mrp < this.priceCalcForm.value.finalPrice) {
      this.notify(false, "Final price should be less than MRP");

    } else if (this.priceCalcForm.valid && this.priceCalcForm.value.finalPrice > 0) {
      this.popup.showPriceCalcForm = false;
      let resellingPriceConfig: any = this.priceCalcForm.value;
      if (this.selectedResellingCategory) {
        resellingPriceConfig.resellingCategory = this.selectedResellingCategory.CategoryName;
      }
      this.productForm.controls['resellingPriceConfig'].setValue(resellingPriceConfig);
      this.notifyConfirmInit();
    } else {
      this.notify(false, "Invalid final price");

    }
  }

  public saveResellingPriceConfig() {
    let isValid: boolean = true
    this.variantProductList.map((item) => {
      if (item?.productDetails?.isReselling && item?.productDetails?.resellingPriceConfig && this.selectedResellingCategory) {
        item.productDetails.resellingPriceConfig.resellingCategory = this.selectedResellingCategory.CategoryName;
      }

      if (item?.productDetails?.isReselling && !item?.productDetails?.resellingPriceConfig) {
        isValid = false;
        item.valid = false;
      } else if (!item?.productDetails?.isReselling) {
        item.valid = true;
        item.productDetails.resellingPriceConfig = "";
      } else {
        item.valid = true;
      }
    })

    if (isValid) {
      this.popup.showPriceConfigList = false;
      this.notifyConfirmInit();
    } else {
      this.notify(false, "Reselling price can't be zero");
    }
  }

  public continueClick() {
    if (!this.isDesktop && this.isEdit) {
      this.router.navigate([this.routerPaths.mobileProductList]);
    } else {
      this.productAdded.emit();
      this.initVariantService(0);
      this.popup.showVariantForm = false;
      this.router.navigate([this.routerPaths.mobileProductList]);
    }
  }

  public unitPriceChange() {
    if (this.productForm.value.priceCalcValues) {
      this.productForm.controls['priceCalcValues'].setValue(null);
    }
  }

  public deleteImage(item: any) {
    this.isImagesModified = true;
    const index = this.selectedProduct.imageArray.indexOf(item)
    this.selectedProduct.imageArray.splice(index, 1);
    this.selectedProduct.primaryImage = this.selectedProduct.imageArray[0]?.ImageName ?? "";
  }

  public categoryAdded() {
    this.popup.showCategoryForm = false;
    this.getCategories();
  }

  public addCategoryNavigation() {
    // this.router.navigate(['/products/categories'], {queryParams:{AddCategory:'true'}});
    this.popup.showCategoryForm = true;
  }

  private processProductList() {
    this.productsList.map((item: any) => {
      let currentVariant = JSON.parse(item?.CurrentVariantData ?? '[]')
      item.sizeValue = currentVariant.find((variant: any) => {
        return variant.variantType === "sizeValue"
      })?.variantValue
    })
  }


  //OTHER
  private addOrUpdateSingleProd() { 
    this.loading = true;

    const transformedAdditionalFields = this.productForm.value.additionalFields.length > 0
      ? this.productForm.value.additionalFields.map((field: any) => ({
        AdditionalInfo: {
          label: field.label,
          icon: field.icon || '',
          type: field.type || 'text',
          value: field.value,
          isActive: field.isActive ?? true
        }
      })) : null;

    let params = {
      name: this.productForm.value.productName,
      description: this.productForm.value.description ?? "",
      categoryID: this.productForm.value.categoryId,
      searchKeywords: this.productForm.value.searchKeyword ?? "",
      autoOutOfStock: this.productForm.value.outOfStock ?? false,
      stock: this.productForm.value.stock ?? 0,
      productWeight: this.productForm.value.productWeight ?? 0,

      image: this.selectedProduct?.primaryImage ?? "",
      multiImages: this.selectedProduct?.imageArray ?? [],

      unitPrice: this.productForm.value.unitPrice,
      purchasePrice: this.productForm.value.purchasePrice ?? 0,
      mrp: this.productForm.value.mrp ?? 0,
      discount: this.productForm.value.discountAmount ?? 0,
      mrpDiscount: this.productForm.value.mrpDiscountAmount ?? 0,
      sgst: this.productForm.value.priceCalcValues?.sgst ?? this.productForm.value.cgst,
      cgst: this.productForm.value.priceCalcValues?.cgst ?? this.productForm.value.sgst,
      sellerPriceConfig: this.genSellingPriceConfigString(this.productForm.value.priceCalcValues),
      resellingPriceConfig: this.genResellingPriceConfigString(this.productForm.value.resellingPriceConfig),
      isReselling: false,

      id: this.productForm.value.id,
      variantGroup: this.variantGroup,
      hasVariants: false,
      isItemVariant: false,
      currentVariantData: "[{}]",
      productVariants: [],
      parentProductId: 0,
      modificationNotificationConfig: (this.productForm.value.notifyConfig) ? JSON.stringify(this.productForm.value.notifyConfig) : "{}",
      isProductPublished: this.productForm.value.isProductPublished ?? true,
      SeoKeywords: this.productForm.value.SeoKeywords ?? "",
      ExternalProductLink: this.productForm.value.ExternalProductLink ?? "",
      additionalInfo: transformedAdditionalFields ? JSON.stringify(transformedAdditionalFields) : "{}",
      deliveryChargeProductID: this.productForm.value.deliveryChargeProductID ?? 0,
      productType: 'inventory',
      productTag: this.productForm.value.productTag ?? '',
    }

    params.isReselling = (params.resellingPriceConfig !== "{}" && !this.isReseller) ? true : false;

    if (this.isEdit) {
      this.updateProductDetails(params);
    } else {
      this.addProductDetails(params);
    }
  }

  public itrateProductList() {
    let singleVariant = this.variantProductList.find((item: any) => { return item.status === "pending" });
    if (singleVariant) {
      if (this.isEdit && !singleVariant.touched) {
        this.afterProdAddSuccess(singleVariant.id, singleVariant)

      } else {
        this.addOrUpdateAllProd(singleVariant);
      }
    }
  }

  private addOrUpdateAllProd(singleVariant: any) {
    let transformedAdditionalFields = singleVariant.productDetails.additionalFields?.length > 0
      ? singleVariant.productDetails.additionalFields.map((field: any) => ({
        AdditionalInfo: {
          label: field.label || '',
          icon: field.icon || '',
          type: field.type || 'text',
          value: field.value || '',
          isActive: field.isActive ?? true
        }
      })) : null;
    let params = {
      name: singleVariant.productDetails.productName,
      description: singleVariant.productDetails.description ?? '',
      categoryID: singleVariant.productDetails.categoryId,
      searchKeywords: singleVariant.productDetails.searchKeyword ?? '',
      autoOutOfStock: singleVariant.productDetails.outOfStock ?? false,
      stock: singleVariant.productDetails.stock ?? 0,
      productWeight: singleVariant.productDetails.productWeight ?? 0,

      image: singleVariant.primaryImage ?? '',
      multiImages: singleVariant.imageArray ?? [],

      unitPrice: singleVariant.productDetails.unitPrice,
      purchasePrice: singleVariant.productDetails.purchasePrice ?? 0,
      mrp: singleVariant.productDetails.mrp ?? 0,
      discount: singleVariant.productDetails.discountAmount ?? 0,
      mrpDiscount: singleVariant.productDetails.mrpDiscountAmount ?? 0,
      cgst: singleVariant.productDetails.priceCalcValues?.cgst ?? singleVariant.productDetails.cgst,
      sgst: singleVariant.productDetails.priceCalcValues?.sgst ?? singleVariant.productDetails.sgst,
      sellerPriceConfig: this.genSellingPriceConfigString(singleVariant.productDetails.priceCalcValues),
      resellingPriceConfig: this.genResellingPriceConfigString(singleVariant.productDetails.resellingPriceConfig),
      isReselling: false,

      id: singleVariant.productDetails.id,
      variantGroup: this.variantGroup,
      hasVariants: true,
      isItemVariant: this.variantGroup == 0 ? false : true,
      currentVariantData: this.genCurrentVariantDataString(singleVariant),
      productVariants: [],
      parentProductId: 0,
      modificationNotificationConfig: (singleVariant.productDetails.notifyConfig) ? JSON.stringify(singleVariant.productDetails.notifyConfig) : "{}",
      isProductPublished: singleVariant.productDetails.isProductPublished ?? true,
      SeoKeywords: singleVariant.productDetails.SeoKeywords ?? '',
      ExternalProductLink: singleVariant.productDetails.ExternalProductLink ?? '',
      additionalInfo: transformedAdditionalFields ? JSON.stringify(transformedAdditionalFields) : "{}",
      productTag: singleVariant.productDetails.productTag ?? '',
    }

    params.isReselling = (params.resellingPriceConfig === "{}") ? false : true;

    if (this.isEdit && params.id != 0) {
      this.updateProductDetails(params, singleVariant);
    } else {
      this.addProductDetails(params, singleVariant);
    }
  }

  private afterProdAddSuccess(ID: any, singleVariant?: any) {
    this.productAddedOrUpdatedSuccess.emit();
    if (this.variantForm.value.isProductHaveVariant == "yes") {
      singleVariant.status = "success";
      if (this.variantGroup === 0) {
        this.variantGroup = ID;
      }
      this.trackProgress('success');
      this.itrateProductList();

    } else {
      if (this.isDesktop) {
        this.getproductList();

      } else if (this.isEdit) {
        this.router.navigate([this.routerPaths.mobileProductList]);
      }
      let msg = this.isEdit ? 'Product updated successfully' : 'Product added successfully';
      this.ProductAddSuccessBannerHead = msg
      const idToUse = this.isEdit ? this.ProductIdForPoduct : ID;
      this.getProductDetails(idToUse)
      this.productSuccessConfirmationBanner = true;
      this.setAddForm();
      this.router.navigate([this.routerPaths.mobileProductList]);
    }
  }

  private afterProdAddFailed(singleVariant?: any) {
    this.loading = false;
    this.error();
    if (this.variantForm.value.isProductHaveVariant == "yes") {
      singleVariant.status = "failed";
      this.trackProgress('failed');
      this.itrateProductList();

    } else {
      let msg = this.isEdit ? 'Product updated failed' : 'Product added failed';
      this.notify(false, msg);
    }
  }

  public trackProgress(status: string) {
    if (status == 'success') {
      this.variantProgrss.success++;
    } else {
      this.variantProgrss.failed++;
    }
    this.productAddProgress++;
    let totalProducts = this.variantProductList.length;
    let progress = (this.productAddProgress / totalProducts) * 100
    this.progressPercent = progress;
    this.progressPercentStr = progress + '%';
    if (this.productAddProgress == this.variantProductList.length) {
      this.saveVariants(this.variantGroup);
      if (this.isDesktop) {
        this.getproductList();
      }
    }
  }

  public deleteProductClick(item: any) {
    this.productToDelete = item;

    if (this.isDesktop) {
      this.conService.confirm({
        message: 'Do you want to delete this product?',
        header: 'Confirmation',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.deleteProductConfirmed();
        },
      });
    } else {
      this.popup.showProdDelete = true;
    }
  }

  public deleteProductConfirmed() {
    this.popup.showProdDelete = false;
    let params = {
      ID: this.productToDelete.productDetails?.id ?? 0,
      VariantGroup: this.variantGroup
    }

    if (params.ID == 0) {
      this.removeFromArray();
    } else {
      this.deleteProduct(params);
      this.removeFromArray();
    }
  }

  private removeFromArray() {
    const index = this.variantProductList.findIndex((i: any) => {
      return (i.colorValue == this.productToDelete.colorValue && i.sizeValue == this.productToDelete.sizeValue);
    });
    if (index != -1) {
      this.variantProductList.splice(index, 1);
    }
    if (!this.variantProductList.length) {
      let routePath = this.isDesktop ? 'Product/ProductList' : 'products/product-list';
      this.router.navigate([routePath]);
    }
  }


  // API METHODS
  public getproductList(params?: any) {
    this.loading = true;
    if (!params) {
      params = {
        takeAll: false,
        skip: 0,
        take: 100,
        categoryID: 0,
        keyword: '',
        productsFor: 'admin',
        organisationID: 0,
        productTag: '',
      };
    }
    this.productService.getProductList(params).subscribe((res: any) => {
      this.loading = false;
      if (res.Result == "Success") {
        this.productsList = res.ResponseData;
        this.productsListLength = res.RowCount;
        this.processProductList();
      }
    }, (error: HttpErrorResponse) => {
      this.error();
      this.loading = false;
    })
  }

  public getCategories() {
    this.loading = true;
    this.productService.getSubCategories(0).subscribe((res: any) => {
      this.loading = false;
      if (res.Result == "Success") {
        this.categoryList = res.ResponseData;
        this.resultCat = res.ResponseData;
      }
    }, (error: HttpErrorResponse) => {
      this.loading = false;
      this.error();
    });
  }

  private getDomainCategories() {
    this.productService.getSellerDomainCategories().subscribe((res: any) => {
      if (res && res?.Result == "Success" && res?.ResponseData) {
        let categoryObj = JSON.parse(res.ResponseData);
        this.domainCategoryList = categoryObj.categories.split(',').map((item: any, index: number) => {
          let categoryItem = {
            // id: (index + 1),
            CategoryName: item,
            // is_Selected: false
          }
          return categoryItem
        })
        // this.CategoryList.unshift({id: 0, CategoryName: "All Categories", is_Selected: true});
      }
    }, (err: HttpErrorResponse) => {
      // console.error(err)
    })
  }

public readProductImage(fileEvent: any) {
  this.loading = true;
  const inputElement = fileEvent.target as HTMLInputElement;
  if (inputElement.files && inputElement.files[0]) {
    this.fileToUpload = inputElement.files[0];

    const fileSizeInBytes = this.fileToUpload.size;
    const maxSizeInBytes = 500 * 1024;
    if (fileSizeInBytes > maxSizeInBytes) {
      this.notify(false, 'File size exceeds the limit of 500KB');
      this.loading = false;
      inputElement.value = '';
      return;
    }

    const fileName = this.fileToUpload.name;
    const extension = fileName.substring(fileName.lastIndexOf('.') + 1);
    const imageNameOnly = this.configService.getLoginDetails();

    // Prepare FormData for streaming upload
    const formData = new FormData();
    formData.append('file', this.fileToUpload, fileName);
    formData.append('imageName', this.selectedProduct?.productDetails?.productName || `${imageNameOnly.SellerName}_productName`);
    formData.append('imageType', 'ProductImage');
    formData.append('extension', extension);
    formData.append('ProductID', this.isEdit ? this.selectedProduct?.productDetails?.id.toString() : '0');

    this.productService.uploadUsingFileStream(formData).subscribe({
      next: (res: any) => {
        this.loading = false;
        if (res && res.Result === 'Success') {
          if (!this.selectedProduct?.imageArray?.length) {
            this.selectedProduct.imageArray = [];
            this.selectedProduct.primaryImage = res.ResponseData;
          }
          this.selectedProduct.imageArray.push({ ImageName: res.ResponseData });
          if (!this.selectedProduct.primaryImage) {
            this.selectedProduct.primaryImage = res.ResponseData;
          }
          this.isImagesModified = true;
        }
        inputElement.value = '';
      },
      error: (err: HttpErrorResponse) => {
        this.loading = false;
        this.error();
        inputElement.value = '';
      }
    });
  }
}


public readColorIcon(fileEvent: any, variant: any, index: any) {
  const fileToUpload: File = fileEvent.target.files.item(0);
  if (!fileToUpload) return;

  const fileName = fileToUpload.name;
  const extension = fileName.substring(fileName.lastIndexOf('.') + 1);
  const imageNameOnly = this.configService.getLoginDetails();

  // Prepare FormData for file stream upload
  const formData = new FormData();
  formData.append('file', fileToUpload, fileName);
  formData.append('imageName', this.selectedProduct?.productDetails?.productName || `${imageNameOnly.SellerName}_productName`);
  formData.append('imageType', 'ColorIcon');
  formData.append('extension', extension);
  formData.append('ProductID', this.isEdit ? this.selectedProduct?.productDetails?.id.toString() : '0');

  this.productService.uploadUsingFileStream(formData).subscribe({
    next: (res: any) => {
      if (res && res.Result === 'Success') {
        this.onEnterNewColor(variant, index);
        variant.controls['colorIcon'].setValue(res.ResponseData);
      } else {
        this.loading = false;
        this.error();
      }
    },
    error: (err: HttpErrorResponse) => {
      this.loading = false;
      this.error();
    }
  });
}


  public getSellerCategorySettings() {
    this.productService.GetSellerCategorySettings().subscribe((res: any) => {
      if (res.Result == "Success") {
        let variantTypeFor = res.ResponseData.filter((item: { SettingsName: string; }) => item.SettingsName = 'Variant');
        variantTypeFor.map((variantType: any) => {
          if (variantType.SettingsValue == 'Size') {
            this.IsSizeEnabled = true;
            this.getVariantsWithTyp('Size');
          }
          if (variantType.SettingsValue == 'Color') {
            this.IsColorEnabled = true;
          }
        });
      }
    }, (err: HttpErrorResponse) => {
      // this.error();
    })
  }

  public getVariantsWithTyp(variantTypeFor: string) {
    let params = {
      variantTypeFor: variantTypeFor
    }
    this.productService.getVariantTypeMastersByVariantTypeFor(params).subscribe((res: any) => {
      if (res.Result == "Success") {
        this.sizeValues = res.ResponseData;
        this.addVariantField();
      }
    }, (err: HttpErrorResponse) => {
      // this.error();
    })
  }

  public getAllTax() {
    this.productService.getAllTaxMasters().subscribe((res: any) => {
      if (res.Result == "Success") {
        this.gstTypes = res.ResponseData;
      }
    }, (err: HttpErrorResponse) => {
      // this.error();
    })
  }

  public saveVariants(variantGroup: any) {
    let params = {
      variantGroup: variantGroup
    }
    this.productService.saveProductVariants(params).subscribe((res: any) => {
      if (res.Result == 'Success') {

      }
    }, (err: HttpErrorResponse) => {
      this.error();
    })
  }

  public deleteProduct(product: any, productParams?: any) {
    let params = {
      id: product.ID,
      variantGroup: product.VariantGroup,
    }
    this.productService.deleteProduct(params).subscribe((res: any) => {
      if (res.Result == "Success") {
        if (this.isDesktop) {
          this.getproductList(productParams);
        }
        this.notify(true, 'Product delete successfully');
      } else {
        this.notify(false, 'Product delete failed');
      }
      // this.saveVariants(product.VariantGroup);
    }, (err: HttpErrorResponse) => {
      this.notify(false, 'Product delete failed');
    })
  }

  // update product
  private updateProductDetails(params: any, singleVariant?: any) {
    this.productService.updateProduct(params).subscribe((res: any) => {
      this.loading = false;
      if (res.Result == "Success") {
        this.ProductIdForPoduct = params.id
        this.afterProdAddSuccess(res.ResponseData, singleVariant)
      } else {
        this.afterProdAddFailed();
      }
    }, (error: HttpErrorResponse) => {
      this.afterProdAddFailed();
    });
  }

  // add product
  private addProductDetails(params: any, singleVariant?: any) { 
    this.productService.addProduct(params).subscribe((res: any) => {
      this.loading = false;
      if (res?.Result == 'Success' && Number(res?.ResponseData)) {
        this.afterProdAddSuccess(res.ResponseData, singleVariant)
        this.productAdded.emit();
      } else if (res?.Result == 'Success' && res?.ResponseData) {
        this.notify(false, res.ResponseData);
      } else {
        this.afterProdAddFailed();
      }
    }, (error: HttpErrorResponse) => {
      this.afterProdAddFailed();
    })
  }

  private generatePreviousData() {
    let data: any = {
      CategoryName: this.productDetailBackup.CategoryName,
      Image: this.productDetailBackup?.Image ?? ""
    }
    if (this.productForm.value.unitPrice != this.productDetailBackup.UnitPrice) {
      data.UnitPrice = this.productDetailBackup.UnitPrice;
    }
    if (this.isImagesModified) {
      data.MultiImages = this.productDetailBackup?.MultiImages ?? [];
    }
    const isImageChanged = (this.selectedProduct?.primaryImage != this.productDetailBackup?.Image);
    return (Object.keys(data).length > 2 || isImageChanged) ? JSON.stringify(data) : "";
  }

  private generateModifiedData() {
    let data: any = {
      // CategoryName: this.productDetailBackup.CategoryName,
      // Image: this.selectedProduct?.primaryImage ?? ""
    }
    if (this.productDetailBackup?.Image != this.selectedProduct?.primaryImage) {
      data.Image = this.selectedProduct?.primaryImage;
    }
    if (this.productForm.value.unitPrice != this.productDetailBackup.UnitPrice) {
      data.UnitPrice = this.productForm.value.unitPrice;
    }
    if (this.isImagesModified) {
      data.MultiImages = this.selectedProduct?.imageArray ?? [];
    }
    // const isImageChanged = (this.selectedProduct?.primaryImage != this.productDetailBackup?.Image);
    return (Object.keys(data).length) ? JSON.stringify(data) : "";
  }


  private saveChangeRequest() {
    let params = {
      // id: this.productDetailBackup.ID,
      // productId: this.productDetailBackup.ParentProductId,
      // id: 0,
      productId: this.productDetailBackup.ID,
      sellerId: this.productDetailBackup.ParentSellerId,
      productName: this.productDetailBackup.ProductName,
      modifiedData: this.generateModifiedData(),
      previousData: this.generatePreviousData(),
      requestStatus: "Pending",
    }

    if (params.modifiedData == "" || params.previousData == "") {
      this.notify(false, "Nothing changed");
    } else {
      this.productService.saveProductChangeRequest(params).pipe(
        tap((res: any) => {
          if (res && res?.Result == "Success" && res?.ResponseData == "Success") {
            this.notify(true, 'Modification request sent');
            if (this.isDesktop) {
              this.getproductList();

            } else if (this.isEdit) {
              setTimeout(() => { //navigate with delay to show tost message
                this.router.navigate([this.routerPaths.mobileProductList]);
              }, 1000)
            }
            this.setAddForm();
          } else if (res && res?.Result == "Success" && res?.ResponseData == "Already") {
            this.notify(false, "Request already exist");

          } else {
            this.notify(false, "Product update failed");
          }

        }),
        catchError((err: HttpErrorResponse) => {
          this.loading = false;
          this.notify(false, "Unknown error occured, try again");
          throw err;
        })
      ).subscribe();
    }

  }

  SetProductUrl(ProductDetails: any) {
    const AdminDetails = this.configService.getLoginDetails();
    const subDomain = AdminDetails?.SubDomain;
    const productName = this.sanitizeProductName(ProductDetails.ProductName);
    const productId = ProductDetails.ID;

    const url = `https://${subDomain}/productdetails/${productName}/${productId}`;
    this.productUrl = url;
  }

  private sanitizeProductName(name: string): string {
    return name.toLowerCase().replace(/[^a-z0-9]+/g, '-');
  }

  safeJsonParse(str: string) {
    try {
      return str ? JSON.parse(str) : null;
    } catch (e) {
      console.error("Failed to parse JSON string", e);
      return null;
    }
  }

  public processAIGeneratedDescription(data: any) {
    let AIGeneratedDescription = data.candidates;
    if (AIGeneratedDescription && AIGeneratedDescription.length) {
      const textContent = AIGeneratedDescription[0]?.content?.parts[0]?.text;
      this.generatedDescription = textContent;
      this.PatchAIGeneratedDataInProductForm(textContent)
    } else {
      this.generatedDescription = 'No description found';
    }
  }

  public PatchAIGeneratedDataInProductForm(data: string) {
    let ExtractedTitle = {
      productNameMatch: data.match(/^\*\*Name:\*\*\s*(.*)$/m),
      searchKeywordsMatch: data.match(/^\*\*Search Keywords:\*\*\s*([\s\S]*?)(?=^\*\*SEO Keywords:\*\*|\*\*Description:\*\*)/m),
      seoKeywordsMatch: data.match(/^\*\*SEO Keywords:\*\*\s*([\s\S]*?)(?=^\*\*Description:\*\*)/m),
      descriptionMatch: data.match(/^\*\*Description:\*\*\s*([\s\S]*)$/m)
    };
    let ExtractedData = {
      productName: ExtractedTitle.productNameMatch ? ExtractedTitle.productNameMatch[1].trim().replace(/[-*]/g, '') : null,
      searchKeywords: ExtractedTitle.searchKeywordsMatch ? ExtractedTitle.searchKeywordsMatch[1].trim().split('\n').map((keyword: any) => keyword.replace(/^[-*]/, '').trim()).filter(Boolean) : [],
      seoKeywords: ExtractedTitle.seoKeywordsMatch ? ExtractedTitle.seoKeywordsMatch[1].trim().split('\n').map(keyword => keyword.replace(/^[-*]/, '').trim()).filter(Boolean) : [],
      description: ExtractedTitle.descriptionMatch ? ExtractedTitle.descriptionMatch[1].trim() : null
    };
    if (ExtractedData.description) {
      ExtractedData.description = this.convertAsterisksToHtml(ExtractedData.description)
    }
    if (ExtractedData.productName == null || ExtractedData.description == null || ExtractedData.searchKeywords == null || ExtractedData.seoKeywords == null) {
      this.notify(false, "Generating content failed. Please try again.");
      return;
    }
    this.productForm.patchValue({
      productName: ExtractedData.productName,
      searchKeyword: ExtractedData.searchKeywords.length > 0 ? ExtractedData.searchKeywords.join(', ') : '',
      SeoKeywords: ExtractedData.seoKeywords.length > 0 ? ExtractedData.seoKeywords.join(', ') : '',
      description: ExtractedData.description.replace(/^[\s*-]*/g, '\n')
    });
  }

  public selectFuelType(item: any) {
    this.productForm.controls['fuelType'].setValue(item);
  }

  public selectTransamissionType(item: any) {
    this.productForm.controls['transmissionType'].setValue(item);
  }

  convertAsterisksToHtml(text: string): string {
    if (!text) return '';
    let html = text.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');
    html = html.replace(/^\*\s+(.+)$/gm, '<li>$1</li>');
    html = html.replace(/(<li>.+?<\/li>)/gms, '<ul>$1</ul>');
    html = html.replace(/\n\s*\n/g, '</p><p>');
    html = `<p>${html}</p>`;
    html = html.replace(/\n/g, '<br>');
    return html;
  }

  public processAIGeneratedWebsiteContent(data: any, websiteForm: FormGroup) {
    const text = data?.candidates?.[0]?.content?.parts?.[0]?.text;
    if (!text) {
      this.notify(false, 'Empty AI content');
      return;
    }

    const extract = (label: string): string => {
      const regex = new RegExp(`\\*\\*${label}:\\*\\*\\s*([\\s\\S]*?)(?=\\n\\*\\*|$)`);
      const match = text.match(regex);
      return match ? match[1].trim() : '';
    };

    const patchValues = {
      sliderHeading: extract('Site Header'),
      sliderDescription: extract('Site Description'),

      aboutSectionHeading: extract('About Section Heading'),
      aboutHead: extract('About Header'),
      aboutDescription: extract('About Description'),

      aboutSection1: extract('About Section 1'),
      aboutHeading1: extract('About Heading 1'),
      aboutDescriptions1: extract('About Description 1'),
      aboutSection2: extract('About Section 2'),
      aboutHeading2: extract('About Heading 2'),
      aboutDescriptions2: extract('About Description 2'),

      uspSectionHead: extract('USP Section Heading'),
      uspHead1: extract('USP Name 1'),
      uspDescription1: extract('USP Description 1'),
      uspHead2: extract('USP Name 2'),
      uspDescription2: extract('USP Description 2'),
      uspHead3: extract('USP Name 3'),
      uspDescription3: extract('USP Description 3'),

      featureName1: extract('Feature 1 Name'),
      featureDescription1: extract('Feature 1 Description'),
      featureName2: extract('Feature 2 Name'),
      featureDescription2: extract('Feature 2 Description'),
      featureName3: extract('Feature 3 Name'),
      featureDescription3: extract('Feature 3 Description'),
      featureName4: extract('Feature 4 Name'),
      featureDescription4: extract('Feature 4 Description'),

      screenShotHeading: extract('Screenshot Section Heading'),
      menuscreenShotHeading: extract('Screenshot Menu Header'),
      screenShotDescription: extract('Screenshot Description'),

      faqHeading: extract('FAQ Heading'),
      menufaqHeading: extract('FAQ Menu Header'),
      faqDescription: extract('FAQ Description'),

      helpVideoSectionHead: extract('Help Video Section Heading'),
      helpVideoHeading: extract('Help Video Heading'),
      helpvideoSectionHead: extract('Help Video Title'),
      menuhelpVideoHeading: extract('Help Video Menu Header'),
      helpVideDescription: extract('Help Video Description'),

      FooterDescription: extract('Footer Description'),

      workingFlowDataHeading: extract('Working Flow Data Heading'),
      menuworkingFlowDataHeading: extract('Menu Working Flow Data Heading'),
      workingFlowDataDescription: extract('Working Flow Data Description'),
      step1Heading: extract('Step 1 Heading'),
      step1Description: extract('Step 1 Description'),
      step2Heading: extract('Step 2 Heading'),
      step2Description: extract('Step 2 Description'),
      step3Heading: extract('Step 3 Heading'),
      step3Description: extract('Step 3 Description'),

      feturesHeading: extract('Features Heading'),
      menufeturesHeading: extract('Menu Features Heading'),
      feturesDescription: extract('Features Description'),

    };

    const siteDetailsGroup = websiteForm.get('siteDetails') as FormGroup;

    const SeoPatchValue = {
      SeoKeyword: extract('SEO Keywords'),
      MetaTags: extract('SEO Title'),
      MetaData: extract('SEO Description'),
    };

    siteDetailsGroup.patchValue(SeoPatchValue);

    websiteForm.patchValue(patchValues);

    // Parse 6 FAQs
    const faqFormArray = websiteForm.get('faQs') as FormArray;
    faqFormArray.clear();
    for (let i = 1; i <= 6; i++) {
      const question = extract(`Question ${i}`);
      const answer = extract(`Answer ${i}`);
      faqFormArray.push(new FormGroup({
        Question: new FormControl(question),
        Answer: new FormControl(answer)
      }));
    }

    this.notify(true, 'AI website content generated successfully.');
  }

public getDeliveryChargeDetailsByProductId(productId: any) {
  this.loading = true;
  this.productService.getDeliveryChargeDetailsByProductId(productId).subscribe((res: any) => {
    this.loading = false;
    if (res.Result == "Success") {
     this.selectedDeliveryCharge = res.ResponseData[0];
    }
  }, (error: HttpErrorResponse) => {
    this.loading = false;
    this.error();
  });
}

public getDeliveryChargeItems() {
  this.productService.GetDeliveryCharge().subscribe((res: any) => {
    if(res.Result === 'Success' && res.ResponseData){
      this.data = res.ResponseData;
    }
  });
}

}